import React, { Component } from "react";
import lang from "../../lang/index";
import { Grade, ImageView , Gender, OfficialAuth} from "../../component/user-ui";
import Observer from '../../lib/observer';

class ListItem extends Component {
    static defaultProps = {
        item: {},
        onClick: function(){},
        showList: ['username','gender', 'grade', 'signature']
    };

    constructor(props) {
        super(props);
    }

    jumpProfile(uid) {
        hashHistory.push('/profile/base/' + uid);

        this.props.onClick();
    }

    render() {
        let item = this.props.item;
        console.log('搜索',item)
        let  linkTo;

        if (item.onlineFlag) {
            linkTo = "/living/"+longToString(item.roomUid)+"/"+longToString(item.roomId)
        } else {
            linkTo = "/profile/base/"+longToString(item.roomUid);
        }
        return (
            <li data-uid={item.uid}>
                <div className="list-item" onClick={() => this.jumpProfile(item.uid)}>
                    <div className="avatar">
                        <Observer>{isVisible => <ImageView src={item.avatar} lazyload={true} size={50} circle isVisible={isVisible} />}</Observer>
                        { item.officialAuth > 0 ? <OfficialAuth value={item.officialAuth}/> : null }
                    </div>
                    <div className="refbox">
                        <div className="user">
                        {
                            this.props.showList.map((key, index)=>{
                                if (key == 'gender') {
                                    return  item.gender ? <Gender key="gender" value={item.gender}/> : null;
                                }

                                if (key == 'grade') {
                                    return item.grade ? <Grade key="grade" value={item.grade}/> : null;
                                }

                                return (
                                    <div key={index} className={key}>{item[key]}</div>      
                                );
                            })
                        }
                        </div>
                    </div>
                </div>
                { this.props.children }
            </li>
        );
    }
}

export default ListItem;



// WEBPACK FOOTER //
// ./js/profile/host-card/host-item.js